import { writable } from 'svelte/store';

import { API_BASE_URL } from '../config.js';

// The API's base URL comes from the build's environment (.env.<mode>, see .env.example): production for
// npm run build, the mocked API for tests.
export const BASE_URL = API_BASE_URL

export const loginToken = writable(null);
export const userDetails = writable(null);

export const userConfig = writable({ "featureSwitch": {} });

export const userContext = writable(null);

export const mainMenuToggle = writable(false);
export const avatarImageSrc = writable(null);

export const exerciseList = writable([]);
export const exercisePos = writable(0);

export const apiToken = writable("");
export const apiDomain = writable("");

export const lastRecording = writable(false);